import getExtendedOgDefs from "./extendedOgDef";

const getTableFields = (createTableList, tableName) => {
  // console.log("~ recvd: tableList: " + JSON.stringify(tableList));
  //console.log("~~ " + JSON.stringify(ogTableDef));

  let ogTableDef = getExtendedOgDefs(createTableList);
  let tgtTable = ogTableDef[tableName];
  if (tgtTable && tgtTable !== undefined && tgtTable !== null) {
    let finalArray = Object.keys(tgtTable).map(key => {
      return {
        name: tgtTable[key].caption,
        fieldName: key
      };
    });

    //console.log(JSON.stringify(finalArray));
    return finalArray;
  } else {
    return [];
  }
};

export default getTableFields;



// WEBPACK FOOTER //
// ./src/app/components/TableDefinitions/getTableFields.jsx